export var IntervalType;
(function (IntervalType) {
    IntervalType["CRON"] = "cron";
    IntervalType["RATE"] = "rate";
})(IntervalType || (IntervalType = {}));
export var ComponentMode;
(function (ComponentMode) {
    ComponentMode["CREATE"] = "create";
    ComponentMode["UPDATE"] = "update";
})(ComponentMode || (ComponentMode = {}));
//# sourceMappingURL=oh-create-auto-report.types.js.map
